export default class Accordion {
    constructor() {
        this.init();
    }

    init() {
        this.acc();
    }

    acc() {
        //アコーディオン
        const $triggers = document.querySelectorAll(".js-acc_trigger");

        $triggers.forEach((el) => {
            el.addEventListener("click", (e) => {
                const parent = el.closest(".js-acc");
                const wrapper = el.nextElementSibling;
                const height =
                    wrapper.querySelector(".js-acc_cont").offsetHeight;
                const heightplus = height + 4;

                el.classList.toggle("-active");

                if (
                    getComputedStyle(wrapper, null).getPropertyValue(
                        "height"
                    ) === "0px"
                ) {
                    wrapper.style.height = `${heightplus}px`;

                    if (parent !== null) {
                        //高さを足していく
                        parent.style.height = `${
                            parent.offsetHeight + heightplus
                        }px`;
                    }
                } else {
                    wrapper.style.height = 0;
                    if (parent !== null) {
                        //高さを引いていく
                        parent.style.height = `${
                            parent.offsetHeight - heightplus
                        }px`;
                    }
                }
            });
        });
    }
}
